import { decodeToken } from "react-jwt";

interface IClaims {
    name: string;
    given_name: string;
    family_name: string;
}

const decodeAccessToken = (rememberMe?:boolean): IClaims | null => {
    const token = rememberMe ? localStorage.getItem("accessToken"): sessionStorage.getItem("accessToken");

    if (token) {
        const claims: IClaims | null = decodeToken(token);
        return claims;
    }

    return null;
}

export const getDisplayName = (rememberMe?:boolean): string => {
    return decodeAccessToken(rememberMe)?.name ?? "";
}

export const getGivenName = (rememberMe?:boolean): string => {
    return decodeAccessToken(rememberMe)?.given_name ?? "";
}

export const getFamilyName = (rememberMe?:boolean): string => {
    return decodeAccessToken(rememberMe)?.family_name ?? "";
}